// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__jdP4S","disabled":"FileBtn_disabled__2oerp","warn":"FileBtn_warn__lFMNt","fade":"FileBtn_fade__2Uste"};